// extracted by mini-css-extract-plugin
export default {"page_wrapper":"NotFound404_page_wrapper__ni1Ik","content_wrapper":"NotFound404_content_wrapper__febmE","link_button":"NotFound404_link_button__CoPUd"};